import React from 'react';

function Impressum() {
  return (
    <div className="home-container">
      <div className="home-header">
        <h1>IMPRESSUM</h1>
      </div>
      <section>
        <h2>Für den Inhalt verantwortlich</h2>
        <address>
          <p>
            <strong>
              Bundesforschungs- und Ausbildungszentrum für Wald, Naturgefahren
              und Landschaft (BFW)
            </strong>
            <br />
            Seckendorff-Gudent-Weg 8<br />
            A-1131 Wien<br />
            <a href="http://bfw.ac.at" target="_blank" rel="noopener noreferrer">
              http://bfw.ac.at
            </a>
          </p>
        </address>

        <p><strong>Eigentümerin des BFW:</strong> Republik Österreich</p>
        <p><strong>Aufsichtsbehörde:</strong> Bundesministerium für Land- und Forstwirtschaft, Klima- und Umweltschutz, Regionen und Wasserwirtschaft</p>

        <p>
          <strong>Leiter des BFW:</strong><br />
          Dipl.-Ing. Dr. Peter Mayer
        </p>

        <p>
          <strong>Tel. national:</strong> 01/878 38 - 0<br />
          <strong>Tel. international:</strong> +43 1 878 38 - 0
        </p>

        <p>
          <strong>Fax national:</strong> 01/878 38 - 1250<br />
          <strong>Fax international:</strong> +43 1/878 38 - 1250
        </p>

        <p>
          <strong>E-Mail:</strong>{' '}
          <a href="mailto:direktion@bfw.gv.at">direktion@bfw.gv.at</a>
        </p>
      </section>
<br />
      <section>
        <h2>Bankverbindung / Firmenbuch</h2>
        
        <p>
          <strong>BIC:</strong> BAWAATWW<br />
          <strong>IBAN:</strong> AT09 6000 0000 9605 0844<br />
          <strong>Bankleitzahl:</strong> 60000<br />
          <strong>Kontonummer:</strong> PSK 96.050.844
        </p>
        <p>
          <strong>Firmenbuchgericht:</strong> Handelsgericht Wien, FN 257240 w<br />
          <strong>UID-Nummer:</strong> ATU 61289616<br />
          <strong>DVR:</strong> 0099384
        </p>
      </section>
<br />
      <section>
        <h2>Gegenstand des Unternehmens</h2>
        <p>
          Das Bundesforschungs- und Ausbildungszentrum für Wald, Naturgefahren und Landschaft (BFW) ist eine österreichische, multidisziplinäre Forschungs- und Ausbildungsstelle des Bundes in der Rechtsform „Anstalt öffentlichen Rechts“. Das BFW unterstützt die ökonomisch, ökologisch und sozial nachhaltige Entwicklung der Gesellschaft durch die Erarbeitung von wissenschaftlichen Grundlagen und durch Wissensvermittlung zur multifunktionalen Nutzung natürlicher Ressourcen. Das BFW dient unter anderem dem Bund als Forschungs-, Ausbildungs- und Weiterbildungsstelle sowie als Informations-, Koordinations- und Beratungsstelle in den Bereichen Wald, Naturgefahren und Landschaft. Der Aufgabenbereich ist im BFW-Gesetz (Teil des Agrarrechtsänderungsgesetzes) und Forstgesetz (Bundesgesetzblatt 83/2004) näher festgelegt.
        </p>
        
<br />
        
      </section>
<br />
      <section>
        <h2>Copyright</h2>
        <p>
         Das BFW ist Urheber und Werknutzungsberechtigter der zur Verfügung gestellten Information und Inhaber aller sonstigen damit zusammenhängenden Schutzrechte. Die Vervielfältigung von Texten und Daten einschließlich der (digitalen) Speicherung und Nutzung auf optischen und elektronischen Datenträgern darf nur mit vorheriger schriftlicher Zustimmung durch das BFW erfolgen. Die Verwendung der Texte und Daten einschließlich Einspeisung in Online-Dienste, Datenbanken oder Homepages durch unberechtigte Dritte sowie die Veränderung oder Verfälschung von Informationen ist untersagt. Der Download sowie der Ausdruck zum persönlichen, nicht kommerziellen Gebrauch sind jedoch gestattet. 
        </p>
        
      </section>
<br />
      <section>
        <h2>Haftung</h2>
        <p>
          Das BFW prüft und aktualisiert die Informationen auf seinen Webseiten ständig. Trotz aller Sorgfalt können sich die Daten inzwischen geändert haben. Eine Haftung oder Gewährleistung für die Aktualität, Richtigkeit und Vollständigkeit der zur Verfügung gestellten Informationen kann daher nicht übernommen werden. 
        </p>
        <p>
          Des Weiteren behält sich das BFW vor, Änderungen oder Ergänzungen der bereitgestellten Informationen vorzunehmen. 
        </p>
        <p>
         Den auf den Webseiten angebotenen Informationen kommt keine Rechtsverbindlichkeit zu.
        </p>
        <p>
          Die Webseiten des BFW können Links zu Webseiten anderer Anbieter enthalten, für die das BFW keine Verantwortung oder Haftung übernimmt. 
        </p>
       
      </section>
      <br></br>
      <section>
        <h2>Datenschutzerklärung</h2>
        <a href="https://www.bfw.gv.at/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" >Link zur Datenschutzerklärung des BFW</a>
      </section>
    </div>
  );
}

export default Impressum;
